import React, { useEffect, useState } from 'react';
import { NavLink, Route } from 'react-router-dom';
import { fetchSinToken } from '../../../helpers/fetch';
import { Loader } from '../../loader/Loader';
import { NuevoRegisterForm } from './NuevoRegisterForm';

export const BodyTemplateRegister = ({
    component: Component,
    match: { params },
    ...rest
}) => {
    const [loading, setLoading] = useState(true);
    const [parametros, setParametros] = useState({})
    const [valid, setValid] = useState(false)

    useEffect(() => {
        getParametros();
    }, []);

    const getParametros = async () => {
        const resp = await fetchSinToken(`preregistro/${params.id}`);
        const data = await resp.json();
        console.log(data);
        if(!data.ok){
            setValid(false);
        } else{
            setParametros(data.data);
            setValid(true);
        }
        setLoading(false);
    }

    return (
        <Route {...rest}
        component={ (props)=>(
            loading ? <Loader />
            : valid ? <NuevoRegisterForm {...props} parametros={parametros}/>
                : <>
                    <h3 className="text-danger text-center mb-4">Esta url de registro no es válido o ya venció</h3>
                    <NavLink to="/login" className="btn btn-primary btn-block">
                        <i className="fa fa-arrow-left"></i> Regresar a Login
                    </NavLink>
                </>
        )}
        />
    )
}
